<template>
  <router-view />
</template>

<!-- eslint-disable vue/block-lang -->
<script setup>
import { provide } from 'vue'
import { setColorScheme, themes, modes } from '@onxmaps/ys-tokens'
import { FISH_THEME } from '@/lib/theme-utils'
import { useAppForegrounded } from '@/composables/app-foregrounded'
import { isActive } from '@/services/feature-flag-service'
import { featureAccess, FAFeatureFlagClient } from '@onxmaps/feature-access'
import { globalFeatures, fishFeatures } from '@/services/feature-access'
import { Vertical } from '@/types/verticals'
import split from '@/lib/split'

featureAccess.configure({
  featureProviders: [globalFeatures, fishFeatures],
  apiURL: window.environment.apiUrl,
  vertical: Vertical.Fish,
  featureFlagClients: {
    split: new FAFeatureFlagClient(split, ({ ready }) => {
      split.splitClientsReady().then(ready)
    }),
  },
})

provide('theme', FISH_THEME)

setColorScheme({
  theme: themes.FISH,
  mode: isActive('core_debug_dark_mode') ? modes.SYSTEM : modes.LIGHT,
})
useAppForegrounded()
</script>
